import { Backdrop } from "./backdrop";
import { MAIN_COLUMN, PLATE_BLUR, SECTIONS } from "./content";
import { Hero } from "./Hero";
import { MainColumn, Screen } from "./screen";
import { Section } from "./section";
import styles from "./EasterEggPage.module.css";

/**
 * The easter egg: a painted screen, and a column of sections filling it top to
 * bottom. Built to the mobile frame in Figma, and currently what `/` serves —
 * see App.tsx for why, and for when that stops being true.
 */
export function EasterEggPage() {
  return (
    <Screen>
      <Backdrop />

      <MainColumn {...MAIN_COLUMN}>
        <Hero />

        {SECTIONS.map((section) => (
          <Section
            key={section.id}
            heading={section.heading}
            lines={section.lines}
            layout={section.layout}
            blur={PLATE_BLUR}
            plateClassName={styles.plate}
            headingClassName={`type-heading-2 ${styles.ink}`}
            lineClassName={`type-body ${styles.ink}`}
          />
        ))}
      </MainColumn>
    </Screen>
  );
}
